
export default {
  state: {
    coupon: null, // coupon applied to the cart
    cart: [
      /**
       * Just add the full stripe product object to the cart.
       * Add a parameter called "plans" with the structure
       * [ ...{
       *   plan:     // plan ID
       *   quantity: // the number of plans
       * } ... ]
       *
       * When we add "good" type products to the cart we can filter on these as needed
       *
       *
       */
    ]
  },
  getters: {},
  actions: {
    addProductPlanToCart({}, data){
      const { product, plan } = data


      const saveProduct = {
        ...product,
        plans: [

        ]
      }


    }
  },
  mutations: {
    ADD_PRODUCT_TO_CART(state, product) {
      state.cart = state.cart.unshift(product)
    }
  }
}
